import React, { useState } from 'react';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import {
    ChevronDown,
    Search,
    User,
    Phone,
    Mail,
    Bell,
    MoreHorizontal,
    Filter,
    Download,
    Plus
} from 'lucide-react';

export default function MyStudent() {
    const [selectedStandard, setSelectedStandard] = useState('Standard - 8');
    const [selectedDivision, setSelectedDivision] = useState('Division - C');

    const studentsData = [
        { sn: '01', id: 101, name: 'Alice Thompson', grade: 'Grade 10A', email: 'alice.t@gmail.com', phone: '+1 234 567 890', status: 'Active' },
        { sn: '02', id: 105, name: 'David Brown', grade: 'Grade 10A', email: 'david.b@gmail.com', phone: '+1 234 567 891', status: 'Active' },
        { sn: '03', id: 102, name: 'John Doe', grade: 'Grade 10A', email: 'john.d@gmail.com', phone: '+1 234 567 892', status: 'On Leave' },
        { sn: '04', id: 103, name: 'Michael Smith', grade: 'Grade 10A', email: 'michael.s@gmail.com', phone: '+1 234 567 893', status: 'Active' },
        { sn: '05', id: 104, name: 'Sarah Wilson', grade: 'Grade 10A', email: 'sarah.w@gmail.com', phone: '+1 234 567 894', status: 'Active' },
        { sn: '06', id: 106, name: 'James Davis', grade: 'Grade 10A', email: 'james.d@gmail.com', phone: '+1 234 567 895', status: 'Inactive' },
        { sn: '07', id: 107, name: 'Emma Miller', grade: 'Grade 10A', email: 'emma.m@gmail.com', phone: '+1 234 567 896', status: 'Active' },
        { sn: '08', id: 108, name: 'Oliver Wilson', grade: 'Grade 10A', email: 'oliver.w@gmail.com', phone: '+1 234 567 897', status: 'Active' },
    ];

    return (
        <div className="flex h-screen bg-[#F8FAFC] overflow-hidden font-sans">
            <Sidebar />

            <main className="flex-1 overflow-y-auto px-8">
                <Header
                    title="Student Management"
                    subtitle={`Directory of students for ${selectedStandard} • ${selectedDivision}`}
                    showStandardSelector={true}
                    showDivisionSelector={true}
                    selectedStandard={selectedStandard}
                    selectedDivision={selectedDivision}
                    setSelectedStandard={setSelectedStandard}
                    setSelectedDivision={setSelectedDivision}
                >
                    {/* Search Bar Refined */}




                    <button className="flex items-center gap-2 px-5 py-2.5 bg-blue-500 text-white rounded-xl text-[14px] font-bold shadow-lg shadow-blue-100 hover:bg-blue-600 transition-all">
                        <Plus size={18} />
                        Add Student
                    </button>
                </Header>

                {/* Main Content Table Card */}
                <div className="bg-white rounded-[32px] border border-gray-100 shadow-sm overflow-hidden flex flex-col mb-10">
                    <div className="p-8 flex items-center justify-between border-b border-gray-50">
                        <div className="flex items-center gap-6">
                            <h3 className="text-[20px] font-black text-[#111827]">Student directory</h3>
                            <div className="flex items-center gap-2">
                                <span className="w-2.5 h-2.5 bg-emerald-500 rounded-full animate-pulse"></span>
                                <span className="text-gray-400 font-bold text-[14px]">180 Records Total</span>
                            </div>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="relative group">
                                <Search size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-blue-500 transition-colors" />
                                <input
                                    type="text"
                                    placeholder="Search by name..."
                                    className="pl-11 pr-4 py-2.5 bg-white border border-gray-100 rounded-xl text-[14px] font-bold text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-100 transition-all w-64"
                                />
                            </div>
                            <button className="flex items-center gap-2 px-4 py-2.5 bg-white border border-gray-100 rounded-xl text-[14px] font-bold text-gray-700 shadow-sm hover:bg-gray-50">
                                <Filter size={18} className="text-gray-400" />
                                Filter
                            </button>
                            <button className="p-2 text-gray-400 hover:text-gray-900 transition-colors">
                                <Download size={20} />
                            </button>
                            <button className="p-1.5 text-gray-400 hover:text-gray-900 transition-colors">
                                <MoreHorizontal size={22} />
                            </button>
                        </div>
                    </div>

                    <div className="overflow-x-auto">
                        <table className="w-full text-left">
                            <thead className="bg-[#F8FAFC]">
                                <tr>
                                    <th className="px-8 py-5 text-[12px] font-black text-gray-400 tracking-widest uppercase text-center">S/N</th>
                                    <th className="px-6 py-5 text-[12px] font-black text-gray-400 tracking-widest uppercase">Student Info</th>
                                    <th className="px-6 py-5 text-[12px] font-black text-gray-400 tracking-widest uppercase">Contact</th>
                                    <th className="px-6 py-5 text-[12px] font-black text-gray-400 tracking-widest uppercase">Grade</th>
                                    <th className="px-8 py-5 text-[12px] font-black text-gray-400 tracking-widest uppercase">Status</th>
                                    <th className="px-8 py-5 text-[12px] font-black text-gray-400 tracking-widest uppercase text-right">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {studentsData.map((v, i) => (
                                    <tr key={i} className="border-b border-gray-50 last:border-0 hover:bg-slate-50 transition-all group">
                                        <td className="px-8 py-5 text-[14px] font-bold text-gray-500 text-center">{v.sn}</td>
                                        <td className="px-6 py-5">
                                            <div className="flex items-center gap-4">
                                                <div className="w-11 h-11 rounded-xl bg-blue-50 text-blue-500 flex items-center justify-center overflow-hidden border border-blue-100 group-hover:scale-105 transition-transform">
                                                    <img src={`https://api.dicebear.com/7.x/initials/svg?seed=${v.name}`} alt="" className="w-full h-full object-cover" />
                                                </div>
                                                <div>
                                                    <p className="text-[15px] font-black text-[#111827] group-hover:text-blue-500 transition-colors">{v.name}</p>
                                                    <p className="text-[12px] font-bold text-gray-400">ID: SCT-{v.id}</p>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="px-6 py-5">
                                            <div className="flex flex-col gap-1">
                                                <div className="flex items-center gap-2 text-[13px] font-bold text-gray-700">
                                                    <Mail size={14} className="text-gray-400" />
                                                    {v.email}
                                                </div>
                                                <div className="flex items-center gap-2 text-[13px] font-bold text-gray-500">
                                                    <Phone size={14} className="text-gray-400" />
                                                    {v.phone}
                                                </div>
                                            </div>
                                        </td>
                                        <td className="px-6 py-5 text-[14px] font-black text-[#111827]">{v.grade}</td>
                                        <td className="px-8 py-5">
                                            <span className={`text-[11px] font-black px-3 py-1.5 rounded-lg inline-block text-center uppercase tracking-widest ${v.status === 'Active' ? 'text-emerald-500 bg-emerald-50/50' :
                                                v.status === 'On Leave' ? 'text-amber-500 bg-amber-50/50' :
                                                    'text-gray-400 bg-gray-50'
                                                }`}>
                                                {v.status}
                                            </span>
                                        </td>
                                        <td className="px-8 py-5 text-right">
                                            <div className="flex items-center justify-end gap-1">
                                                <button className="p-2 text-gray-400 hover:text-blue-500 hover:bg-blue-50 rounded-xl transition-all">
                                                    <Mail size={18} />
                                                </button>
                                                <button className="p-2 text-gray-400 hover:text-amber-600 hover:bg-amber-50 rounded-xl transition-all">
                                                    <MoreHorizontal size={18} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="p-8 border-t border-gray-50 flex items-center justify-between bg-[#F8FAFC]/30">
                        <div className="flex items-center gap-2 text-[14px] font-bold text-gray-400">
                            Showing 1-8 of 180 total records
                        </div>
                        <div className="flex items-center gap-3">
                            <div className="flex items-center bg-white border border-gray-100 rounded-xl overflow-hidden shadow-sm">
                                <button className="px-4 py-2 text-[14px] font-bold text-gray-400 hover:text-gray-800 border-r border-gray-100 disabled:opacity-30">Previous</button>
                                <div className="px-4 py-2 text-[14px] font-black text-blue-500 bg-blue-50/50">1</div>
                                <button className="px-4 py-2 text-[14px] font-bold text-gray-600 hover:text-gray-800 hover:bg-gray-50">Next</button>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}
